import {
  DEFAULT_DISCOVERY_GUIDE_PROFILE,
  DISCOVERY_GUIDE_PERSONA_ID,
  resolveDiscoveryGuideProfile,
  type DiscoveryGuideProfile,
} from '@common/domain/discovery-guide';
import type { Persona } from '../api/Persona';

export const SCOUT_GUIDE_PROFILE = DEFAULT_DISCOVERY_GUIDE_PROFILE;
export const SCOUT_PERSONA_ID = DISCOVERY_GUIDE_PERSONA_ID;
export const SCOUT_AVATAR_IMAGE_URL = SCOUT_GUIDE_PROFILE.imageURL;

export const SCOUT_PERSONA: Persona = {
  id: SCOUT_PERSONA_ID,
  tenantId: SCOUT_GUIDE_PROFILE.tenantId,
  category: SCOUT_GUIDE_PROFILE.category,
  name: SCOUT_GUIDE_PROFILE.displayName,
  title: SCOUT_GUIDE_PROFILE.title,
  temperature: 0.3,
  responseMaxTokens: 1200,
  imageURL: SCOUT_GUIDE_PROFILE.imageURL,
  personality: SCOUT_GUIDE_PROFILE.personality,
  discoveryGuideProfileId: SCOUT_GUIDE_PROFILE.id,
};

export function isScoutPersona(persona?: Persona | null): boolean {
  return persona?.id === SCOUT_PERSONA_ID;
}

export function resolveScoutGuideProfile(persona?: Persona | null): DiscoveryGuideProfile {
  return resolveDiscoveryGuideProfile(persona?.discoveryGuideProfileId);
}

export function includeScoutPersona(personas: Persona[]): Persona[] {
  if (personas.some((persona) => persona.id === SCOUT_PERSONA_ID)) {
    return personas.map((persona) =>
      persona.id === SCOUT_PERSONA_ID
        ? {
          ...SCOUT_PERSONA,
          ...persona,
          name: resolveScoutGuideProfile(persona).displayName,
          imageURL: persona.imageURL || resolveScoutGuideProfile(persona).imageURL,
        }
        : persona
    );
  }
  return [SCOUT_PERSONA, ...personas];
}
